'use client';
import { useState } from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa6';

const skinTypes = ['normal', 'dry', 'oily', 'combination', 'sensitive'];

interface SkinTypeFilterProps {
  selectedTypes: string[];
  onSelect: (types: string[]) => void;
}

export default function SkinTypeFilter({
  selectedTypes,
  onSelect,
}: SkinTypeFilterProps) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSkinType = (type: string) => {
    const newSelected = selectedTypes.includes(type)
      ? selectedTypes.filter((t) => t !== type)
      : [...selectedTypes, type];
    onSelect(newSelected);
  };

  return (
    <div
      className={`sidebar-filter sidebar-filter--collapsible mb-40 ${isCollapsed ? 'is-collapsed' : ''}`}
    >
      <div
        className="sidebar-filter__header d-flex justify-between align-items-center cursor-pointer"
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <h3 className="sidebar-filter__title mb-0">Skin Type</h3>
        <button
          type="button"
          className="sidebar-filter__toggle btn btn-link p-0"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsCollapsed(!isCollapsed);
          }}
        >
          {isCollapsed ? <FaPlus size={14} /> : <FaMinus size={14} />}
        </button>
      </div>

      {!isCollapsed && (
        <div className="sidebar-filter__content mt-3">
          <div className="skin-type-filter">
            {skinTypes.map((type) => (
              <div key={type} className="form-check mb-2">
                <input
                  type="checkbox"
                  id={`skin-type-${type}`}
                  checked={selectedTypes.includes(type)}
                  onChange={() => toggleSkinType(type)}
                  className="form-check-input"
                />
                <label
                  htmlFor={`skin-type-${type}`}
                  className="form-check-label"
                >
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
